export enum FilterOperatorEnum {
  Equal = 1,
  NotEqual = 2,
  Like = 3,
  NotLike = 4,
  StartsWith = 5,
  EndsWith = 6,
  Greater = 7,
  Less = 8,
  GreaterEqual = 9,
  LessEqual = 10,
  Empty = 11,
  NotEmpty = 12,
  Between = 13,
  NotBetween = 14,
  IsTrue = 15,
  IsFalse = 16,
  IsIn = 17
}
